import * as Yup from "yup";
import { AddressInputSchema } from "../common/SharedAddressInput/schemas";
import { createIndividualInformationInputSchema } from "../IndividualInformationInput/schemas";
import { IndividualProfileFormValues } from "./types";

export const createIndividualProfileSchema =
  (): Yup.ObjectSchema<IndividualProfileFormValues> =>
    Yup.object({
      ...createIndividualInformationInputSchema.fields,
      ...AddressInputSchema.fields,
    }) as Yup.ObjectSchema<IndividualProfileFormValues>;
